import {
	BtnInfoPanTool,
  DomEventListener,
  DBxEvent,
  DomUtil
} from "cartovista";

    export default class BtnInfoPanToolExtend extends BtnInfoPanTool {}

		var _btnInfoPanToolInitialize = BtnInfoPanTool.prototype.initialize;
		BtnInfoPanTool.prototype.initialize = function(e, i, o) {
			this._boundInfoPanToolOnMouseDownExtend = this._btnInfoPanToolOnMouseDownExtend.bind(this);
			this._boundInfoPanToolOnMouseUpExtend = this._btnInfoPanToolOnMouseUpExtend.bind(this);
			this._debouncedInfoBanToolMouseMoveClusterZoom = _.debounce(this._btnInfoPanToolOnMouseMoveClusterZoom.bind(this), 100);
			return _btnInfoPanToolInitialize.call(this, e, i, o);
		};

		var _btnInfoPanToolActivated = BtnInfoPanTool.prototype._activated;
    BtnInfoPanTool.prototype._activated = function() {
        _btnInfoPanToolActivated.call(this);
				DomEventListener.addListener(this._mapController.divMap, "mousedown", this._boundInfoPanToolOnMouseDownExtend);
				DomEventListener.addListener(this._mapController.divMap, "touchstart", this._boundInfoPanToolOnMouseDownExtend);
				DomEventListener.addListener(this._mapController.divMap, "mouseup", this._boundInfoPanToolOnMouseUpExtend);
				DomEventListener.addListener(this._mapController.divMap, "touchend", this._boundInfoPanToolOnMouseUpExtend);
				DomEventListener.addListener(this._mapController.divMap, "mousemove", this._debouncedInfoBanToolMouseMoveClusterZoom);
		};

		var _btnInfoPanToolDeactivated = BtnInfoPanTool.prototype._deactivated;
    BtnInfoPanTool.prototype._deactivated = function() {
        _btnInfoPanToolDeactivated.call(this);
				DomEventListener.removeListener(this._mapController.divMap, "mousedown", this._boundInfoPanToolOnMouseDownExtend);
        DomEventListener.removeListener(this._mapController.divMap, "touchstart", this._boundInfoPanToolOnMouseDownExtend);
        DomEventListener.removeListener(this._mapController.divMap, "mouseup", this._boundInfoPanToolOnMouseUpExtend);
        DomEventListener.removeListener(this._mapController.divMap, "touchend", this._boundInfoPanToolOnMouseUpExtend);
				DomEventListener.removeListener(this._mapController.divMap, "mousemove", this._debouncedInfoBanToolMouseMoveClusterZoom);
};

		BtnInfoPanTool.prototype._btnInfoPanToolOnMouseMoveClusterZoom = function(e) {
        window.cartovista.dispatchEvent(new DBxEvent("Extend_onBtnInfoPanToolMouseMove", {"mouseMoveEvent": e}));
    }

		BtnInfoPanTool.prototype._btnInfoPanToolOnMouseDownExtend = function(e) {
        this._mouseDownCursorPosition = DomUtil.getCursorPosition(e, this._mapController);
    };

    BtnInfoPanTool.prototype._btnInfoPanToolOnMouseUpExtend = function(e) {
			//dispatch Extend_onBtnInfoPanToolMouseUp event only if cursor was not dragged
			var mouseUpCursorPosition = DomUtil.getCursorPosition(e, this._mapController);
			if (this._mouseDownCursorPosition.x == mouseUpCursorPosition.x && this._mouseDownCursorPosition.y == mouseUpCursorPosition.y) {
					window.cartovista.dispatchEvent(new DBxEvent("Extend_onBtnInfoPanToolMouseUp", {"mouseUpEvent": e}));
			}
    };
